// Mini cluster de salud para el bottom nav: arco de 240° (estilo tacómetro) con
// el score al centro, coloreado por estado (rojo <40, ámbar <70, verde). Legible
// a ~24px. Refleja la salud actual de la flota del cliente.
export default function MiniHealthGauge({ score = 0, size = 24 }) {
  const s = Math.max(0, Math.min(100, Math.round(score)));
  const color = s < 40 ? '#E62117' : s < 70 ? '#FFAB00' : '#00C853';
  const r = 14;
  const C = 2 * Math.PI * r;
  const arc = C * (240 / 360);     // pista: 240°
  const prog = arc * (s / 100);    // progreso
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" style={{ display: 'block' }}>
      <g transform="rotate(150 18 18)">
        <circle cx="18" cy="18" r={r} fill="none" stroke="rgba(128,128,128,0.28)" strokeWidth="4" strokeLinecap="round" strokeDasharray={`${arc} ${C}`} />
        <circle cx="18" cy="18" r={r} fill="none" stroke={color} strokeWidth="4" strokeLinecap="round" strokeDasharray={`${prog} ${C}`} />
      </g>
      <text x="18" y="22.5" textAnchor="middle" fontSize="13" fontWeight="800" fill={color} fontFamily="ui-monospace, monospace">{s}</text>
    </svg>
  );
}
